// Servers often answer with a generic message ("Validation failed") plus the details
// (which field, why). Show both so the user can fix the actual problem.
const esc = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export const describeApiError = (error, fallback = "Something went wrong") => {
  const data = error?.response?.data;
  const base = data?.message || (error?.message === "Network Error" ? "Could not reach the server. Check your internet connection." : error?.message) || fallback;
  const raw =
    data?.errors ??
    data?.details ??
    (data?.error && typeof data.error === "object" ? data.error.errors ?? data.error : null);
  const lines = [];
  const push = (e) => {
    if (!e) return;
    if (typeof e === "string") return lines.push(e);
    const field = e.path || e.param || e.field || e.name;
    const msg = e.msg || e.message || e.error;
    if (msg) lines.push(field ? `${field}: ${msg}` : msg);
  };
  if (Array.isArray(raw)) raw.forEach(push);
  else if (raw && typeof raw === "object") {
    Object.entries(raw).forEach(([k, v]) =>
      lines.push(`${k}: ${Array.isArray(v) ? v.join(", ") : typeof v === "string" ? v : v?.message || JSON.stringify(v)}`)
    );
  } else if (typeof data?.error === "string") lines.push(data.error);
  const uniq = [...new Set(lines)].slice(0, 8);
  return [base, ...uniq];
};

export const apiErrorHtml = (error, fallback) =>
  describeApiError(error, fallback).map(esc).join("<br>");
